import { functions, httpsCallable } from '@/firebase';

const commit = httpsCallable(functions, 'commitDomainRuleConfiguration');
const SERVER_FIELDS = new Set(['id', 'schoolId', 'domainId', 'configurationRevision',
  'createdAt', 'createdBy', 'updatedAt', 'updatedBy', 'retired', 'retiredAt', 'retiredBy',
  'creationRequestBy', 'creationConfiguration', 'executionCount', 'lastExecuted', 'lastExecutionDetails']);

export const newDomainRuleId = () => crypto.randomUUID();

export async function commitDomainRuleConfiguration(request) {
  const payload = { ...request };
  if (payload.configuration) {
    payload.configuration = Object.fromEntries(Object.entries(payload.configuration)
      .filter(([key, value]) => value !== undefined && !SERVER_FIELDS.has(key)));
  }
  return (await commit(payload)).data;
}
